interface InsuranceSectionProps {
  provider?: string;
  policyNumber?: string;
  expirationDate?: string;
  errors: Record<string, string>;
  onChange: (field: string, value: string) => void;
}

/**
 * InsuranceSection component for collecting optional insurance information
 */
export function InsuranceSection({ 
  provider = '', 
  policyNumber = '', 
  expirationDate = '',
  errors,
  onChange 
}: InsuranceSectionProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Insurance Information (Optional)</h2>
      <p className="text-sm text-gray-600 mb-4">
        If providing insurance information, all fields must be completed.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label htmlFor="insuranceProvider" className="block text-sm font-medium text-gray-700 mb-1">
            Insurance Provider
          </label>
          <input
            id="insuranceProvider"
            type="text"
            value={provider}
            onChange={(e) => onChange('insuranceProvider', e.target.value)}
            className={`w-full px-3 py-2 border rounded-lg focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 ${
              errors.insurance ? 'border-red-300' : 'border-gray-300'
            }`}
            placeholder="e.g., State Farm"
            aria-invalid={!!errors.insurance}
            aria-describedby={errors.insurance ? 'insurance-error' : undefined}
          />
        </div>
        <div>
          <label htmlFor="policyNumber" className="block text-sm font-medium text-gray-700 mb-1">
            Policy Number
          </label>
          <input
            id="policyNumber"
            type="text"
            value={policyNumber}
            onChange={(e) => onChange('policyNumber', e.target.value)}
            className={`w-full px-3 py-2 border rounded-lg focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 ${
              errors.insurance ? 'border-red-300' : 'border-gray-300'
            }`}
            placeholder="Policy number"
            aria-invalid={!!errors.insurance}
          />
        </div>
        <div>
          <label htmlFor="expirationDate" className="block text-sm font-medium text-gray-700 mb-1">
            Expiration Date
          </label>
          <input
            id="expirationDate"
            type="date"
            value={expirationDate}
            onChange={(e) => onChange('expirationDate', e.target.value)}
            className={`w-full px-3 py-2 border rounded-lg focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 ${
              errors.insurance ? 'border-red-300' : 'border-gray-300'
            }`}
            aria-invalid={!!errors.insurance}
          />
        </div>
      </div>
      {errors.insurance && (
        <p id="insurance-error" className="text-red-600 text-sm mt-2" role="alert">
          {errors.insurance}
        </p>
      )}
    </div>
  );
}
